// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"3a6439fb","93":"2d03cd55","469":"b0b0ee10","480":"28818528","929":"31be413e","967":"0979963f"}[chunkId] + ".chunk.js";
};